import { Dimensions, PixelRatio } from 'react-native';

// For Android the window dimension will exclude the size used by the status bar (if not translucent) and bottom navigation bar
const { width, height } = Dimensions.get('window');

export const SCREEN_WIDTH = width;
export const SCREEN_HEIGHT = height;

// Short desktop/laptop viewports (1024x768, 1366x768, 1280x720) — tighten vertical
// spacing so the Home schedule list isn't pushed off-screen. Width gate keeps phones
// (full-width layout < 500) unaffected.
export const IS_SHORT_VIEWPORT = SCREEN_WIDTH >= 768 && SCREEN_HEIGHT <= 800;

// Per-screen local zoom-out for short viewports. Applied to a SPECIFIC container via
// the `zoom` style (not globally on #root), so the Stack header and the bottom tab bar
// stay full-size. CSS `zoom` scales layout too, so a container with a height divided by
// its zoom factor occupies its full pre-zoom box in the parent (no gap, no clipping).
// RN-web passes `zoom` through to the DOM and treats it as unitless (its `unitlessNumbers`
// list includes `zoom`), so a plain number works — only the TS type needs an `as any`.
// Resolve to 1 on normal/phone viewports so callers can apply them unconditionally.
export const HOME_SHORT_ZOOM = IS_SHORT_VIEWPORT ? 0.75 : 1;
export const QUESTIONNAIRE_SHORT_ZOOM = IS_SHORT_VIEWPORT ? 0.75 : 1;

/**
 * Converts provided width percentage to independent pixel (dp).
 * @param  {string} widthPercent The percentage of screen's width that UI element should cover
 *                               along with the percentage symbol (%).
 * @return {number}              The calculated dp depending on current device's screen width.
 */
export const widthPercentageToDP = (widthPercent: number | string) => {
  // Parse string percentage input and convert it to number.
  const elemWidth = typeof widthPercent === 'number' ? widthPercent : parseFloat(widthPercent);

  // Use PixelRatio.roundToNearestPixel method in order to round the layout
  // size (dp) to the nearest one that correspons to an integer number of pixels.
  return PixelRatio.roundToNearestPixel((SCREEN_WIDTH * elemWidth) / 100);
};

/**
 * Converts provided height percentage to independent pixel (dp).
 * @param  {string} heightPercent The percentage of screen's height that UI element should cover
 *                                along with the percentage symbol (%).
 * @return {number}               The calculated dp depending on current device's screen height.
 */
export const heightPercentageToDP = (heightPercent: number | string) => {
  // Parse string percentage input and convert it to number.
  const elemHeight = typeof heightPercent === 'number' ? heightPercent : parseFloat(heightPercent);

  // Use PixelRatio.roundToNearestPixel method in order to round the layout
  // size (dp) to the nearest one that correspons to an integer number of pixels.
  return PixelRatio.roundToNearestPixel((SCREEN_HEIGHT * elemHeight) / 100);
};
